import { action, computed } from 'mobx'

import { FEATURE_STRIPE_ONBOARDING } from 'supplier/constants'
import { ApiStatusStore, PaypalSettingsStore, StripeOnboardingStore } from 'supplier/stores'

class PaymentSettingsStore {
  /** @type {import('../root').RootStore} */
  root

  apiStatus = new ApiStatusStore()

  /** @type {StripeOnboardingStore} */
  stripeOnboardingStore

  /** @type {PaypalSettingsStore} */
  paypalSettingsStore

  /**
   * @param {import('../root').RootStore} root
   */
  constructor (root) {
    this.root = root
    this.stripeOnboardingStore = new StripeOnboardingStore(root)
    this.paypalSettingsStore = new PaypalSettingsStore(root)
  }

  @computed get isStripeEnabled () {
    return this.root.appConfigStore.isFeatureEnabled(FEATURE_STRIPE_ONBOARDING)
  }

  @action.bound
  async fetch () {
    this.apiStatus.startLoad()

    const stripePromise = this.isStripeEnabled ? this.stripeOnboardingStore.fetch() : Promise.resolve()
    const paypalPromise = this.paypalSettingsStore.fetch()

    try {
      await Promise.all([stripePromise, paypalPromise])
      this.apiStatus.finishLoad()
    } catch (error) {
      this.apiStatus.failLoad('We could not fetch the payment settings. Please try again in a minute.')
      throw error
    }
  }

  @action.bound
  reset () {
    this.apiStatus.reset()
    this.paypalSettingsStore.reset()
  }
}

export default PaymentSettingsStore
